import {Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {DecimalPipe, NgClass, NgIf} from '@angular/common';

@Component({
    selector: 'app-accommodation-payment-details',
    templateUrl: './accommodation-payment-details.component.html',
    styleUrls: ['./accommodation-payment-details.component.scss'],
    standalone: true,
  imports: [NgIf, NgbTooltipModule, TranslateModule, DecimalPipe, NgClass]
})
export class AccommodationPaymentDetailsComponent implements OnInit {

  @Input() public selectedRoom: any;
  @Input() public firstMonthRent: number;
  @Input() public isAllSummaryOpen: boolean = false;
  @Input() public isBtnDisplay: boolean = false;
  @Input() public booking;


  constructor() {
  }

  ngOnInit(): void {
    if (!this.firstMonthRent) {
      this.firstMonthRent = this.getFirstMonthRent();
    }
  }

  public openAllSummary(): void {
    this.isAllSummaryOpen = true;
  }

  public btnDisplayClicked(): void {
    this.isBtnDisplay = !this.isBtnDisplay;
  }

  private getFirstMonthRent(): number {
    let date;
    if (this.booking.start_date) {
      date = new Date(this.booking.start_date);
    } else {
      date = new Date(this.booking.startDate);
    }
    const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const end = new Date(start.getFullYear(), start.getMonth() + 1, 0).getDate();
    return (this.selectedRoom.property_price.price / end) * (end - start.getDate() + 1);
  }

}
